{
  "meni": {
    "title": "Menu"
  },
  "uporabnik": {
    "odjava": "logout"
  },
  "pregled": {
    "title": "Surface Inspection",
    "description": "Report on the inspection of surfaces for aircraft movement"
  },
  "dnevniRazpored": {
    "title": "Daily Flight Schedule",
    "description": "Add / read the daily flight schedule"
  },
  "startnaListaJ": {
    "title": "Start List (Gliders)",
    "description": "Add an entry for a glider"
  },
  "startnaListaM": {
    "title": "Start List (Powered Aircraft)",
    "description": "Add an entry for a powered aircraft"
  },
  "startnaListaUL": {
    "title": "Start List (UltraLight)",
    "description": "Add an entry for an ultralight aircraft"
  },
  "obracuni": {
    "title": "Calculations",
    "description": "Overview of records"
  },
  "porocila": {
    "title": "Reports and Statistics",
    "description": "Overview of flights, hours, and activities"
  },
  "log": {
    "title": "Deletion / Editing Log",
    "description": "Overview of deleted and edited records"
  },
  "dnevnikPilotov": {
    "title": "Pilot Logbook",
    "description": "Entry and review of the personal logbook"
  },
  "dnevnikPilotovJ": {
    "title": "Pilot Logbook (gliding)",
    "description": "Pilot's Personal Logbook for Gliding"
  },
  "nalogLet": {
    "title": "Flight Order",
    "description": "Create and send a flight order"
  },
  "dokumentacijaNalogov": {
    "title": "Order Documentation",
    "description": "Approve / Reject a flight order"
  },
  "sifrantiP": {
    "title": "Pilots",
    "description": "Pilots registry"
  },
  "sifrantiL": {
    "title": "Aircraft",
    "description": "Add aircraft registry"
  },
  "sifrantiK": {
    "title": "Clubs",
    "description": "Clubs registry"
  },
  "nastavitveLeta": {
    "title": "Flight Settings",
    "description": "Training circuits, settings of current conditions, ..."
  },
  "nastavitveIzpisov": {
    "title": "Print Settings",
    "description": "Stamp settings, logo settings, header settings for prints, ..."
  },
  "nastavitve": {
    "title": "Settings",
    "description": "Program settings"
  },
  "pregledDostopov": {
    "title": "Access Overview",
    "description": "Overview of application access"
  },
  "patchNotes": {
    "title": "Patch Notes",
    "description": "Add / Replace patch notes"
  },
  "praviceUporabnikov": {
    "title": "Permission Settings",
    "description": "Setting user permissions (editing, deleting)"
  },
  "deaktivacijaUporabnikov": {
    "title": "Deactivated users",
    "description": "Managing Deactivated Accounts"
  },
  "hr": {
    "dnevniki": "Logs",
    "dokumenti": "Documents",
    "sifranti": "Registries",
    "nastavitveLeta": "Flight / Print Settings",
    "administracija": "Administration",
    "pravice": "User Permissions",
    "upravitelj": "Administrator Settings",
    "briefing": "Briefing"
  },
  "availability": {
      "title": "Availability",
      "description": "Availability Reporting" 
  },
  "camo": {
    "title": "Camo",
    "description": "Camo Maintenance"
  },
  "camo_log": {
    "title": "Camo Logs",
    "description": "Camo Maintenance logs"
  },
  "upravitelj": {
    "title": "Administration settings",
    "description": "Administrator Settings. Administrator name, camo, review settings, ..."
  },
  "wb": {
    "title": "Weight & Balance",
    "description": "Weight & Balance calculation"
  }

}